import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "./pages/HomePage";
import ReaderPage from "./pages/ReaderPage";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

function App() {
  const [language, setLanguage] = useState("fr");

  useEffect(() => {
    const savedLang = localStorage.getItem("language") || "fr";
    setLanguage(savedLang);
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<HomePage language={language} changeLanguage={changeLanguage} />}
          />
          <Route
            path="/read/:day"
            element={<ReaderPage language={language} changeLanguage={changeLanguage} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
